"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = exports.ImportType = exports.ActionCardType = exports.DashboardType = exports.OnboardingStepName = exports.OnboardingTailoredPagesOption = exports.OnboardingExplorerOption = exports.EngagementAlgorithmInheritance = exports.EngagementLevel = exports.EngagementAlgorithmChangeType = exports.AccountLicenseChangedType = exports.AccountStatus = exports.SignupEntryPoint = exports.AuthenticationProvider = exports.PlanLevel = exports.AccountApp = exports.EventOrigin = exports.EventName = void 0;
/**
  * Human readable, standardised names for all CTR telemetry events.
  */
var EventName;
(function (EventName) {
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["AccountCreated"] = "Account Created";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["AccountLicenseChanged"] = "Account License Changed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UserCreated"] = "User Created";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UserAdded"] = "User Added";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UserRemoved"] = "User Removed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UserLoggedIn"] = "User Logged In";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UserInvited"] = "User Invited";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["InviteRequestDeleted"] = "Invite Request Deleted";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["InviteRequestSubmitted"] = "Invite Request Submitted";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ProjectCreated"] = "Project Created";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ProjectViewed"] = "Project Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ReportViewed"] = "Report Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EngagementLevelChanged"] = "Engagement Level Changed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EngagementAlgorithmChanged"] = "Engagement Algorithm Changed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EngagementAlgorithmCreateStarted"] = "Engagement Algorithm Create Started";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EngagementLibraryViewed"] = "Engagement Library Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageEngagementPopoverViewed"] = "Page Engagement Popover Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageEngagementAlgorithmAssigned"] = "Page Engagement Algorithm Assigned";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageInheritedTemplateEngagementAlgorithm"] = "Page Inherited Template Engagement Algorithm";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["TemplateEngagementAlgorithmAssigned"] = "Template Engagement Algorithm Assigned";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["TemplateEngagementPopoverViewed"] = "Template Engagement Popover Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EngagementPermissionsUpdated"] = "Engagement Permissions Updated";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["OnboardingStepCompleted"] = "Onboarding Step Completed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["DashboardBannerCardPressed"] = "Dashboard Banner Card Pressed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["DashboardBannerDismissed"] = "Dashboard Banner Dismissed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageAnalyticsViewed"] = "Page Analytics Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageAnalyticsClosed"] = "Page Analytics Closed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PageAnalyticsSessionViewViewed"] = "Page Analytics Session View Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ViewerTimelineTabViewed"] = "Viewer Timeline Tab Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["TimeFilterSelected"] = "Time Filter Selected";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["CollaboratorPageViewed"] = "Collaborator Page Viewed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["BrandImported"] = "Brand Imported";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["BrandConfigured"] = "Brand Configured";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["AccountSubdomainAdded"] = "Account Subdomain Added";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["TokenInserted"] = "Token Inserted";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EmailChanged"] = "Email Changed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ProductTourStepCompleted"] = "Product Tour Step Completed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["ProductTourDismissed"] = "Product Tour Dismissed";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["EmailNotificationSettingsUpdated"] = "Email Notification Settings Updated";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["PropagateOverrides"] = "Propagate Overrides";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["UploadedDocument"] = "Uploaded Document";
    /**
      * See <a href="">here</a> for the event attributes.
      */
    EventName["OnboardingSpecialistMeetingBooked"] = "Onboarding Specialist Meeting Booked";
})(EventName || (exports.EventName = EventName = {}));
;
/**
  * An `EventOrigin` value can represent one of the following:
  *
  * - The user path/flow taken to get to this event.
  *
  *
  * - The current feature in context when the event occurred.
  *
  *
  * - The system event/trigger that lead to this event.
  *
  */
var EventOrigin;
(function (EventOrigin) {
    /**
      * Change of `Plan Level` in the **Admin Tool**.
      */
    EventOrigin["AdminToolPlan"] = "admin_tool_plan";
    /**
      * Change of total seats in the **Admin Tool**.
      */
    EventOrigin["AdminToolSeats"] = "admin_tool_seats";
    /**
      * Event triggered from the **Admin Tool**.
      */
    EventOrigin["AdminTool"] = "admin_tool";
    /**
      * An event has been triggered as part of a flow from a cron job.
      */
    EventOrigin["QwilrJobs"] = "qwilr_jobs";
    /**
      * A **Qwilr App** user Converted.
      */
    EventOrigin["QwilrConversion"] = "qwilr_conversion";
    /**
      * A user invited to the **Qwilr App**.
      */
    EventOrigin["QwilrUserInvited"] = "qwilr_user_invited";
    /**
      * A user removed from the **Qwilr App**.
      */
    EventOrigin["QwilrUserRemoved"] = "qwilr_user_removed";
    /**
      * A **Qwilr** user logged in.
      */
    EventOrigin["QwilrLogin"] = "qwilr_login";
    /**
      * An action performed from the team settings in **Qwilr App**.
      */
    EventOrigin["QwilrTeamSettings"] = "qwilr_team_settings";
    /**
      * An action performed from the brand settings in **Qwilr App**.
      */
    EventOrigin["QwilrBrandSettings"] = "qwilr_brand_settings";
    /**
      * An action performed from the subdomain settings in **Qwilr App**.
      */
    EventOrigin["QwilrSubdomainSettings"] = "qwilr_subdomain_settings";
    /**
      * A user requested an invite to **Qwilr App**.
      */
    EventOrigin["QwilrInviteRequest"] = "qwilr_invite_request";
    /**
      * An action performed from the share panel in **Qwilr App**.
      */
    EventOrigin["QwilrTeamSharePanel"] = "qwilr_team_share_panel";
    /**
      * A user asked to be invited to **Qwilr App** via a collaborator page
      */
    EventOrigin["QwilrCollaboratorComment"] = "qwilr_collaborator_comment";
    /**
      * An event is triggered via the public api.
      */
    EventOrigin["PublicAPI"] = "public_api";
    /**
      * An event triggered when a page is created in the qwilr app.
      */
    EventOrigin["QwilrPageCreation"] = "qwilr_page_creation";
    /**
      * An event triggered when a page is viewed.
      */
    EventOrigin["QwilrPageViewed"] = "qwilr_page_viewed";
    /**
      * An event triggered when a self-service action is done.
      */
    EventOrigin["QwilrSelfService"] = "qwilr_self_service";
    /**
      * A **Springboard** user converted.
      */
    EventOrigin["SpringboardConversion"] = "springboard_conversion";
    /**
      * A **Springboard** user logged in.
      */
    EventOrigin["SpringboardLogin"] = "springboard_login";
    /**
      * Change of `Plan Level` in the **Qwilr App**.
      */
    EventOrigin["QwilrPlan"] = "qwilr_plan";
    /**
      * A **Qwilr** user made an action during onboarding.
      */
    EventOrigin["QwilrOnboarding"] = "qwilr_onboarding";
    /**
      * Action performed while in the dashboard.
      */
    EventOrigin["QwilrDashboard"] = "qwilr_dashboard";
    /**
      * Action performed while in the page editor.
      */
    EventOrigin["QwilrEditor"] = "qwilr_editor";
    /**
      * Action performed via chart interactions.
      */
    EventOrigin["QwilrChart"] = "qwilr_chart";
    /**
      * Action performed using a card component interaction.
      */
    EventOrigin["QwilrCard"] = "qwilr_card";
    /**
      * Event originated from an email deep link.
      */
    EventOrigin["Email"] = "email";
    /**
      * A user signed up in the **Identity Platform**.
      */
    EventOrigin["Signup"] = "signup";
    /**
      * An account being created either in **Qwilr App** or **Springboard**.
      */
    EventOrigin["NewAccount"] = "new_account";
    /**
      * A report has been viewed in the **Qwilr App**.
      */
    EventOrigin["Report"] = "report";
    /**
      * An event emited from the **Identity Platform**.
      */
    EventOrigin["IdentityPlatform"] = "identity_platform";
    /**
      * An event emited via the `create` button click from the Engagement Algorithms page.
      */
    EventOrigin["EngagementCreateButton"] = "engagement_create_button";
    /**
      * An event emited via the `create` button click from a Engagement Algorithms preset.
      */
    EventOrigin["EngagementPreset"] = "engagement_preset";
    /**
      * An event emited via views / operations from the Engagement Algorithms page.
      */
    EventOrigin["EngagementAlgorithms"] = "engagement_algorithms";
    /**
      * An event is triggered from a bulk action
      */
    EventOrigin["BulkAction"] = "bulk_action";
    /**
      * An event is triggered from an action on a single page
      */
    EventOrigin["SinglePage"] = "single_page";
    /**
      * An event emited via views / operations from the Page Analytics page.
      */
    EventOrigin["PageAnalytics"] = "page_analytics";
    /**
      * Event originated from a Slack message's button.
      */
    EventOrigin["SlackMessage"] = "slack_message";
    /**
      * An event is triggered from the **Stripe webhook**.
      */
    EventOrigin["StripeWebhook"] = "stripe_webhook";
    /**
      * An event is triggered from the payments dashboard.
      */
    EventOrigin["PaymentsDashboard"] = "payments_dashboard";
    /**
      * An event is triggered from the payments settings.
      */
    EventOrigin["PaymentsSettings"] = "payments_settings";
    /**
      * An event is triggered from the qwilrpay widget.
      */
    EventOrigin["QwilrPayWidget"] = "qwilrpay_widget";
    /**
      * An event is triggered from the qwilr template library.
      */
    EventOrigin["QwilrTemplateLibrary"] = "qwilr_template_library";
})(EventOrigin || (exports.EventOrigin = EventOrigin = {}));
;
/**
  * A list of apps an `Account` can belong to.
  */
var AccountApp;
(function (AccountApp) {
    /**
      * The **Qwilr App** (for sellers).
      */
    AccountApp["Qwilr"] = "qwilr";
    /**
      * The **Springboard App** (for buyers).
      */
    AccountApp["Springboard"] = "springboard";
})(AccountApp || (exports.AccountApp = AccountApp = {}));
;
/**
  * A list of `Plan Level`s.
  */
var PlanLevel;
(function (PlanLevel) {
    /**
      * Represents the `Pro` plan (no longer available for new accounts).
      */
    PlanLevel["Pro"] = "pro";
    /**
      * Represents the `Business` plan.
      */
    PlanLevel["Business"] = "business";
    /**
      * Represents the `Enterprise` plan.
      */
    PlanLevel["Enterprise"] = "enterprise";
    /**
      * Represents the `Doc Conversion` plan.
      */
    PlanLevel["Doc"] = "doc";
})(PlanLevel || (exports.PlanLevel = PlanLevel = {}));
;
/**
  * The system / mechanism that does user authentication.
  */
var AuthenticationProvider;
(function (AuthenticationProvider) {
    /**
      * **Hubspot** as the authentication provider.
      */
    AuthenticationProvider["Hubspot"] = "hubspot";
    /**
      * **Salesforce** as the authentication provider.
      */
    AuthenticationProvider["Salesforce"] = "salesforce";
    /**
      * **Microsoft** as the authentication provider.
      */
    AuthenticationProvider["Microsoft"] = "microsoft";
    /**
      * **Google** as the authentication provider.
      */
    AuthenticationProvider["Google"] = "google";
    /**
      * **LinkedIn** as the authentication provider.
      */
    AuthenticationProvider["Linkedin"] = "linkedin";
    /**
      * Traditional email + password as the authentication mechanism.
      */
    AuthenticationProvider["Email"] = "email_password";
    /**
      * Authenticate via magic link.
      */
    AuthenticationProvider["MagicLink"] = "magic_link";
})(AuthenticationProvider || (exports.AuthenticationProvider = AuthenticationProvider = {}));
;
/**
  * Where the user signed up from.
  */
var SignupEntryPoint;
(function (SignupEntryPoint) {
    /**
      * Signed up via the standard sign-up flow.
      */
    SignupEntryPoint["Standard"] = "standard";
    /**
      * Signed up via the template page.
      */
    SignupEntryPoint["Template"] = "template";
    /**
      * Signed up via the ai page builder tool.
      */
    SignupEntryPoint["PageBuilderAI"] = "page_builder_ai";
    /**
      * Signed up using the **Document Pack Generator**, which used to be available <a href="https://document-generator.qwilr.com/">here</a>.
      */
    SignupEntryPoint["Dpg"] = "dpg";
    /**
      * Signed up via the **Doc Conversion** tool.
      */
    SignupEntryPoint["AdminPanelDocConversion"] = "admin_panel_doc_conversion";
    /**
      * Signed up via Qwilr's **Identity Platform**.
      */
    SignupEntryPoint["IdentityPlatform"] = "identity";
    /**
      * Signup via single email address form.
      */
    SignupEntryPoint["Quick"] = "quick";
})(SignupEntryPoint || (exports.SignupEntryPoint = SignupEntryPoint = {}));
;
/**
  * A list of `Account Statuses.
  */
var AccountStatus;
(function (AccountStatus) {
    /**
      * Represents the account that is active.
      */
    AccountStatus["Open"] = "open";
    /**
      * Represents the account that has been closed.
      */
    AccountStatus["Closed"] = "closed";
    /**
      * Represents the account that is in a trial plan but the time has expired.
      */
    AccountStatus["Expired"] = "expired";
    /**
      * Represents the account that has been blocked.
      */
    AccountStatus["Blocked"] = "blocked";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
;
/**
  * A summary of the type of license change this event represents.
  *
  * - `conversion`: From trial plan to non-trial plan, or the creation of a non-trial plan.
  *
  *
  * - `upgrade`: From lower plan to higher plan.
  *
  *
  * - `downgrade`: From higher plan to lower plan.
  *
  *
  * - `expand`: Increase seat count without plan change.
  *
  *
  * - `contract`: Decrease seat count without plan change.
  *
  *
  * - `maintain`: Change plan to new version, from monthly to annual license, change minimum seat numbers, or set the account has a custom agreement.
  *
  *
  * - `trial_expire`: An account status changes to expired due to the trial period has ended.
  *
  *
  * - `trial_extend`: The trial period was extended.
  *
  *
  * - `close`: The account got closed.
  *
  *
  * - `reopen`: The account got reopened.
  *
  *
  * - `block`: The account got blocked.
  *
  *
  * - `unblock`: The account got unblocked.
  *
  *
  * - `cancel`: The subscription was cancelled.
  *
  *
  * - `uncancel`: The subscription was uncancelled.
  *
  */
var AccountLicenseChangedType;
(function (AccountLicenseChangedType) {
    /**
      * From trial plan to non-trial plan, or the creation of a non-trial plan.
      */
    AccountLicenseChangedType["Conversion"] = "conversion";
    /**
      * From lower plan to higher plan.
      */
    AccountLicenseChangedType["Upgrade"] = "upgrade";
    /**
      * From higher plan to lower plan.
      */
    AccountLicenseChangedType["Downgrade"] = "downgrade";
    /**
      * Increase seat count without plan change.
      */
    AccountLicenseChangedType["Expand"] = "expand";
    /**
      * Decrease seat count without plan change.
      */
    AccountLicenseChangedType["Contract"] = "contract";
    /**
      *
      * - Change plan to new version
      *<li>From monthly to annual license</li><li>Change minimum seat numbers</li><li>Set the account has a custom agreement</li>
      */
    AccountLicenseChangedType["Maintain"] = "maintain";
    /**
      * Account status changes to expired due to the trial period has ended.
      */
    AccountLicenseChangedType["TrialExpire"] = "trial_expire";
    /**
      * The trial period was extended.
      */
    AccountLicenseChangedType["TrialExtend"] = "trial_extend";
    /**
      * The account got closed.
      */
    AccountLicenseChangedType["Close"] = "close";
    /**
      * The account got reopened.
      */
    AccountLicenseChangedType["Reopen"] = "reopen";
    /**
      * The account got blocked.
      */
    AccountLicenseChangedType["Block"] = "block";
    /**
      * The account got unblocked.
      */
    AccountLicenseChangedType["Unblock"] = "unblock";
    /**
      * The subscription was cancelled.
      */
    AccountLicenseChangedType["Cancel"] = "cancel";
    /**
      * The subscription was uncancelled.
      */
    AccountLicenseChangedType["Uncancel"] = "uncancel";
})(AccountLicenseChangedType || (exports.AccountLicenseChangedType = AccountLicenseChangedType = {}));
;
/**
  * The `EngagementAlgorithmChangeType` represents what action was performed by the user to change the Engagement Algorithm.
  */
var EngagementAlgorithmChangeType;
(function (EngagementAlgorithmChangeType) {
    /**
      * An algorithm has been added
      */
    EngagementAlgorithmChangeType["Add"] = "add";
    /**
      * An algorithm has been deleted.
      */
    EngagementAlgorithmChangeType["Delete"] = "delete";
    /**
      * The algorithm has been activated, i.e. “toggled on”.
      */
    EngagementAlgorithmChangeType["Activate"] = "activate";
    /**
      * The algorithm has been deactivated, i.e. “toggled off.
      */
    EngagementAlgorithmChangeType["Deactivate"] = "deactivate";
    /**
      * Algorithm has been updated.
      */
    EngagementAlgorithmChangeType["Update"] = "update";
})(EngagementAlgorithmChangeType || (exports.EngagementAlgorithmChangeType = EngagementAlgorithmChangeType = {}));
;
/**
  * A summary of the engagement level of the page.
  *
  * - `highlyEngaged`: The buyer has engaged with the page in a certain way or at a recent time which suggests a high level of engagement.
  *
  *
  * - `engaged`: The buyer has engaged with the page in a certain way or at a recent time which suggests a low level of engagement.
  *
  *
  * - `neutral`: This is the default state of pages where there are no known engagement or disengagement signals.
  *
  *
  * - `disengaged`: The buyer has not engaged with the page in a time that suggests a low level of disengagement.
  *
  *
  * - `highlyDisengaged`: The buyer has not engaged with the page in a time that suggests a high level of disengagement.
  *
  *
  * - `unmonitored`: The page is not being monitored at the moment.
  *
  */
var EngagementLevel;
(function (EngagementLevel) {
    /**
      * The buyer has engaged with the page in a certain way or at a recent time which suggests a high level of engagement.
      */
    EngagementLevel["HighlyEngaged"] = "highly_engaged";
    /**
      * The buyer has engaged with the page in a certain way or at a recent time which suggests a low level of engagement.
      */
    EngagementLevel["Engaged"] = "engaged";
    /**
      * This is the default state of pages where there are no known engagement or disengagement signals.
      */
    EngagementLevel["Neutral"] = "neutral";
    /**
      * The buyer has not engaged with the page in a time that suggests a low level of disengagement.
      */
    EngagementLevel["Disengaged"] = "disengaged";
    /**
      * The buyer has not engaged with the page in a time that suggests a high level of disengagement.
      */
    EngagementLevel["HighlyDisengaged"] = "highly_disengaged";
    /**
      * The page is not being monitored at the moment.
      */
    EngagementLevel["Unmonitored"] = "unmonitored";
})(EngagementLevel || (exports.EngagementLevel = EngagementLevel = {}));
;
/**
  * A summary of the engagement algorithm inheritance.
  *
  * - `page`: Assigned to page.
  *
  *
  * - `collection`: Algorithm used because in collection.
  *
  *
  * - `template`: Algorithm used because created from template.
  *
  */
var EngagementAlgorithmInheritance;
(function (EngagementAlgorithmInheritance) {
    /**
      * Assigned to page
      */
    EngagementAlgorithmInheritance["Page"] = "page";
    /**
      * Algorithm used because in collection.
      */
    EngagementAlgorithmInheritance["Collection"] = "collection";
    /**
      * Algorithm used because created from template.
      */
    EngagementAlgorithmInheritance["Template"] = "template";
})(EngagementAlgorithmInheritance || (exports.EngagementAlgorithmInheritance = EngagementAlgorithmInheritance = {}));
;
/**
  * The app landing point chosen upon onboarding completion (for users who didn't complete the Make Qwilr Your Own step and hence saw the Explore screen instead of the Tailored Pages).
  */
var OnboardingExplorerOption;
(function (OnboardingExplorerOption) {
    /**
      * Option to go straight to the dashboard.
      */
    OnboardingExplorerOption["Dashboard"] = "dashboard";
    /**
      * Option to start by creating a page.
      */
    OnboardingExplorerOption["Editor"] = "editor";
    /**
      * Option to start by browsing the template gallery.
      */
    OnboardingExplorerOption["TemplateGallery"] = "template gallery";
    /**
      * Option to upload a document
      */
    OnboardingExplorerOption["Upload"] = "upload";
})(OnboardingExplorerOption || (exports.OnboardingExplorerOption = OnboardingExplorerOption = {}));
;
/**
  * The app landing point user chose on the Tailored Pages screen in the onboarding.
  */
var OnboardingTailoredPagesOption;
(function (OnboardingTailoredPagesOption) {
    /**
      * Option to go straight to the dashboard.
      */
    OnboardingTailoredPagesOption["Dashboard"] = "dashboard";
    /**
      * Option to start by browsing the template gallery.
      */
    OnboardingTailoredPagesOption["TemplateGallery"] = "template gallery";
    /**
      * Option to open the Sales Proposal tailored page in the editor
      */
    OnboardingTailoredPagesOption["SalesProposal"] = "sales proposal";
    /**
      * Option to open the Sales Quote tailored page in the editor
      */
    OnboardingTailoredPagesOption["SalesQuote"] = "sales quote";
    /**
      * Option to open the Digital Marketing Proposal tailored page in the editor
      */
    OnboardingTailoredPagesOption["DigitalMarketingProposal"] = "digital marketing proposal";
    /**
      * Option to upload a document
      */
    OnboardingTailoredPagesOption["Upload"] = "upload";
})(OnboardingTailoredPagesOption || (exports.OnboardingTailoredPagesOption = OnboardingTailoredPagesOption = {}));
;
/**
  * The step from the onboarding that was completed.
  */
var OnboardingStepName;
(function (OnboardingStepName) {
    /**
      * Personal details collection step.
      */
    OnboardingStepName["PersonalDetails"] = "account details";
    /**
      * Invite team members to Qwilr (optional)
      */
    OnboardingStepName["InviteUsers"] = "invite users";
    /**
      * Step to setup brand data including logos, colors and Qwilr subdomain
      */
    OnboardingStepName["MakeQwilrYourOwn"] = "brand setup";
    /**
      * Step to choose the app landing point upon onboarding completion (for users who didn't complete the Make Qwilr Your Own step).
      */
    OnboardingStepName["Explorer"] = "explorer";
    /**
      * Step to choose the app landing point upon onboarding completion (for users who completed setting up their brand in the Make Qwilr Your Own Step).
      */
    OnboardingStepName["TailoredPages"] = "tailored pages";
})(OnboardingStepName || (exports.OnboardingStepName = OnboardingStepName = {}));
;
/**
  * The `DashboardType` represents which dashboard the event was fired from
  */
var DashboardType;
(function (DashboardType) {
    /**
      * Dashboard for pages.
      */
    DashboardType["Pages"] = "pages";
    /**
      * Dashboard for templates.
      */
    DashboardType["Templates"] = "templates";
    /**
      * Dashboard for saved blocks.
      */
    DashboardType["SavedBlocks"] = "saved_blocks";
    /**
      * Dashboard for engagement.
      */
    DashboardType["Engagement"] = "engagement";
    /**
      * Dashboard for automations.
      */
    DashboardType["Automations"] = "automations";
})(DashboardType || (exports.DashboardType = DashboardType = {}));
;
/**
  * The `ActionCardType` represents which action card the user interacted with
  */
var ActionCardType;
(function (ActionCardType) {
    /**
      * User clicked on a card that opens the Welcome page in the editor.
      */
    ActionCardType["Editor"] = "editor";
    /**
      * User clicked on a card that opens the brand settings.
      */
    ActionCardType["BrandSetup"] = "brand_setup";
    /**
      * User clicked on a card that opens the Help panel in the right hand side.
      */
    ActionCardType["Support"] = "support";
    /**
      * User clicked on a card that opens the Typeform iframe for doc conversion requests.
      */
    ActionCardType["DocConversion"] = "doc_conversion";
    /**
      * User clicked on a card that opens the template gallery for them to create a page from.
      */
    ActionCardType["CreateFromTemplate"] = "create_from_template";
    /**
      * User clicked on a card that opens the payments screen to activate QwilrPay.
      */
    ActionCardType["Payments"] = "payments";
    /**
      * User clicked on a card that opens a booking calendar to schedule a meeting with an onboarding specialist.
      */
    ActionCardType["OnboardingSpecialist"] = "onboarding_specialist";
})(ActionCardType || (exports.ActionCardType = ActionCardType = {}));
;
/**
  * The `ImportType` shows whether or not we automatically import the brand data for user in the Make Qwilr Your Own step of the onboarding flow
  */
var ImportType;
(function (ImportType) {
    /**
      * We automatically import the brand data for our user.
      */
    ImportType["Auto"] = "auto";
    /**
      * User clicks the submit button after entering their domain.
      */
    ImportType["Manual"] = "manual";
})(ImportType || (exports.ImportType = ImportType = {}));
;
/**
  * A list of Possible notifications.
  */
var NotificationType;
(function (NotificationType) {
    /**
      * Comment added or resolved
      */
    NotificationType["Comments"] = "comments";
    /**
      * Page engagement level changed
      */
    NotificationType["Engagement"] = "engagement";
    /**
      * A Page was viewed
      */
    NotificationType["Views"] = "views";
    /**
      * Represents the `Doc Conversion` plan.
      */
    NotificationType["Identified"] = "identified";
    /**
      * User tried to view a declined page
      */
    NotificationType["Declined"] = "declined";
    /**
      * User tried to view a expired page
      */
    NotificationType["Expired"] = "expired";
    /**
      * Page Accepted
      */
    NotificationType["Accepted"] = "accepted";
    /**
      * Page Partially Accepted
      */
    NotificationType["PartiallyAccepted"] = "partially_accepted";
    /**
      * Accept Process Stalled
      */
    NotificationType["Stalled"] = "stalled";
    /**
      * A quote was changed
      */
    NotificationType["Quote"] = "quote";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
;
